module.exports = __webpack_public_path__ + "img/Logo.cbcd9007.png";